import "./styles.scss";

import { useMemo, useState } from "react";

import TrackerButton from "components/TrackerButton";
import { ModalWork, ModalDelete, ModalEdit } from "./components";

import useResponsive from "libs/helpers/useResponsive";
import toHoursAndMinutes from "libs/helpers/toHoursAndMinutes";

const mainClass = "task-view-main-tracker";

const Tracker = ({
  id,
  time_entries,
  role,
  timeTracking,
  isActive,
  isCompletelyDisabled,
}) => {
  const { max } = useResponsive();

  const [modalWork, setModalWork] = useState(false);
  const [modalDelete, setModalDelete] = useState(null);
  const [modalEdit, setModalEdit] = useState(null);

  const totalTime = useMemo(() => {
    if (!time_entries || time_entries.length === 0) return 0;

    return time_entries.reduce((acc, entry) => {
      const timeValue = entry.time?.$numberDecimal || entry.time || 0;

      return acc + parseFloat(timeValue);
    }, 0);
  }, [time_entries]);

  const isTrackingAvailable = role === "admin" || role === "webmaster";

  return (
    <>
      <div className={mainClass}>
        {isTrackingAvailable && typeof timeTracking === "function" ? (
          <TrackerButton
            time={{
              $numberDecimal: totalTime || 0,
            }}
            disable_tracking={isCompletelyDisabled}
            isActive={isActive}
            onClick={
              !isCompletelyDisabled
                ? () => {
                    timeTracking(id, null);
                  }
                : undefined
            }
            onLabelClick={
              isTrackingAvailable ? () => setModalWork(true) : undefined
            }
          />
        ) : (
          <p>{totalTime ? toHoursAndMinutes(totalTime)?.formatted : "-"}</p>
        )}
      </div>
      {isTrackingAvailable && (
        <ModalWork
          time_entries={time_entries}
          actions_available={role === "admin"}
          isOpen={modalWork}
          isCompletelyDisabled={isCompletelyDisabled}
          onDelete={(value) => {
            setModalDelete(value);
            setModalWork(false);
          }}
          onEdit={(value) => {
            setModalEdit(value);
            if (!max.sm) setModalWork(false);
          }}
          onClose={() => setModalWork(false)}
        />
      )}
      {role === "admin" && !isCompletelyDisabled && (
        <>
          <ModalDelete
            data={modalDelete}
            time_entries={time_entries}
            isOpen={!!modalDelete}
            onClose={() => {
              setModalWork(true);
              setModalDelete(null);
            }}
          />
          <ModalEdit
            data={modalEdit}
            isOpen={!!modalEdit}
            onClose={() => {
              setModalEdit(null);
              setModalWork(true);
            }}
          />
        </>
      )}
    </>
  );
};

export default Tracker;
